// Photo filenames for Old School
const OLD_SCHOOL_PHOTOS = [
  'old-school-7310_16344911077_z.jpg',
  'old-school-7411_16343138008_c.jpg',
  'old-school-7413_16529109461_w.jpg',
  'old-school-7414_16529775582_z.jpg',
  'old-school-7416_15908248254_c.jpg',
  'old-school-7417_15910640833_c.jpg',
  'old-school-7418_16344910657_m.jpg',
  'old-school-7419_16344910627_m.jpg',
  'old-school-7420_15908247944_m.jpg',
  'old-school-7421_16504816636_m.jpg',
  'old-school-7422_15910640493_m.jpg',
  'old-school-7423_16504816556_m.jpg',
  'old-school-7510-tom--rod_16504816506_c.jpg',
  'old-school-7511_16529108901_c.jpg',
  'old-school-7512_16344548219_c.jpg',
  'old-school-7513_16344548059_c.jpg',
  'old-school-7710_16343364780_m.jpg',
  'old-school-7810_16343364710_z.jpg',
  'old-school-7811_16344547829_z.jpg',
  'old-school-8110_16529108331_c.jpg',
  'old-school-8111_16504815886_c.jpg',
  'old-school-8112_16343364350_m.jpg',
  'old-school-8113_16530843385_m.jpg',
  'old-school-8114_16529774142_m.jpg',
  'old-school-8210_16529108031_z.jpg',
  'old-school-8211_16530843235_c.jpg',
  'old-school-8212_16343136068_c.jpg',
  'old-school-8214_15908246484_c.jpg',
  'old-school-8215_16343135768_c.jpg',
  'old-school-8216_16343363750_z.jpg',
  'old-school-8217_16343363680_m.jpg',
  'old-school-8310_16344546789_c.jpg',
  'old-school-8311_16343376160_c.jpg',
  'old-school-8312_16504827166_c.jpg',
  'old-school-8313_16504827066_c.jpg',
  'old-school-8314_16529119891_c.jpg',
  'old-school-8315_16343147848_c.jpg',
  'old-school-8316_16343375550_z.jpg',
  'old-school-8317_16530854215_c.jpg',
  'old-school-8318_16343375330_c.jpg',
  'old-school-8319_15908257864_c.jpg',
  'old-school-8320_16504826166_c.jpg',
  'old-school-8320a_15910649613_c.jpg',
  'old-school-8320b_16504825896_z.jpg',
  'old-school-8321_16343374730_l.jpg',
  'old-school-8322_16344919657_c.jpg',
  'old-school-8323_15908256974_l.jpg',
  'old-school-8324_16504825206_c.jpg',
  'old-school-8325_16530852805_c.jpg',
  'old-school-8326_16344556809_c.jpg',
  'old-school-8327_16344918877_c.jpg',
  'old-school-8328_16529783092_c.jpg',
  'old-school-8410_16529782932_c.jpg',
  'old-school-8411_16530852085_c.jpg',
  'old-school-8417_16504824436_z.jpg',
  'old-school-8418_16343145068_m.jpg',
  'old-school-8419_15908255694_m.jpg',
  'old-school-8420_16529782532_z.jpg',
  'old-school-8421_15910647833_m.jpg',
  'old-school-8510_15910647803_c.jpg',
  'old-school-8511_16529116651_c.jpg',
  'old-school-8512_15908255334_l.jpg',
  'old-school-8513_15908255054_c.jpg',
  'old-school-8514_16343144238_c.jpg',
  'old-school-8515_16344917367_c.jpg',
  'old-school-8516_16344555219_c.jpg',
  'old-school-8517_16344917097_c.jpg',
  'old-school-8518_16529115441_m.jpg',
  'old-school-8519_16530850375_c.jpg',
  'old-school-8520_16343371370_m.jpg',
  'old-school-8521_16343143618_c.jpg',
  'old-school-8522_16343371170_c.jpg',
  'old-school-8523_16504822396_c.jpg',
  'old-school-8611_16344554329_c.jpg',
  'old-school-8612_16504822096_l.jpg',
  'old-school-8613_15908253584_l.jpg',
  'old-school-8614_16529114401_c.jpg',
  'old-school-8615_16343142648_c.jpg',
  'old-school-8616_16344915527_c.jpg',
  'old-school-8617_16529114091_c.jpg',
  'old-school-8618_15908252884_c.jpg',
  'old-school-8619_16529113811_c.jpg',
  'old-school-8620_16529779772_c.jpg',
  'old-school-8621_16344914987_z.jpg',
  'old-school-8710_16529779612_c.jpg',
  'old-school-8711_16344552829_c.jpg',
  'old-school-8810_16344552649_c.jpg',
  'old-school-8811_15908252044_c.jpg',
  'old-school-8812_16344914507_c.jpg',
  'old-school-8813_16530847865_c.jpg',
  'old-school-9010_16529778772_c.jpg',
  'old-school-9012_16504820066_c.jpg',
  'old-school-9013_16344914077_c.jpg',
  'old-school-9110_16343140718_z.jpg',
  'old-school-9111_16344913857_z.jpg',
  'old-school-9112_15908251224_z.jpg',
  'old-school-9113_16344913697_z.jpg',
  'old-school-9114_16529112241_z.jpg',
  'old-school-9210_16530847225_c.jpg',
  'old-school-9211_16344913407_z.jpg',
  'old-school-9212_16504819356_c.jpg',
  'old-school-9213_16344551019_c.jpg',
  'old-school-9214_16529777652_c.jpg',
  'old-school-9310_15910643063_c.jpg',
  'old-school-9311_16343367670_c.jpg',
  'old-school-9410_16504818856_c.jpg',
  'old-school-9411_15910642793_l.jpg',
  'old-school-9412_15908249994_l.jpg',
  'old-school-9510_16529776932_l.jpg',
  'old-school-9511_16344550149_c.jpg',
  'old-school-9512_16504818316_l.jpg',
  'old-school-9513_16344912027_z.jpg',
  'old-school-9514_16343138848_c.jpg',
  'old-school-9610_16344911757_c.jpg',
  'old-school-9611_16530845565_z.jpg',
  'old-school-9612_15910641703_z.jpg',
  'old-school-9613_15908248954_z.jpg',
  'old-school-7010-pfaff-hd-2_16343366160_c.jpg',
  'old-school-7011--pfaff-hd-old-lou-1_15908248744_z.jpg',
  'old-school-7012-pfaff-hd-3_16504817656_z.jpg',
  'old-school-7013--pfaff-hd-4_16504817576_c.jpg',
  'old-school-7209_16344549149_w.jpg',
];

export default OLD_SCHOOL_PHOTOS;
